import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow } from "mobx";
import { AbstractPostCollection, ClientCollection, RouteHttpVerb } from "@devowl-wp/utils";
import { CookieModel } from "./cookieModel.js";
import { request } from "../utils/request.js";
import { locationRestCookiesOrderPut } from "../wp-api/cookiesOrder.put.js";
class CookieCollection extends AbstractPostCollection {
    get sortedCookies() {
        const result = Array.from(this.entries.values());
        result.sort((a, b)=>{
            if (a.data.menu_order < b.data.menu_order) {
                return -1;
            } else if (a.data.menu_order > b.data.menu_order) {
                return 1;
            } else {
                // a.menu_order === b.menu_order
                if (a.key < b.key) {
                    return 1;
                } else if (a.key > b.key) {
                    return -1;
                } else {
                    return 0;
                }
            }
        });
        return result;
    }
    constructor(store){
        super();
        this.orderCookies = flow(function*(ids) {
            this.busy = true;
            try {
                yield request({
                    location: locationRestCookiesOrderPut,
                    request: {
                        ids
                    }
                });
                // Apply the order to existing cached models instead of fetching again
                let i = 0;
                for (const id of ids){
                    const cookie = this.entries.get(id);
                    cookie.setOrder(i);
                    i++;
                }
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.busy = false;
            }
        });
        this.store = store;
    }
    instance(response) {
        return new CookieModel(this).fromResponse(response);
    }
}
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], CookieCollection.prototype, "sortedCookies", null);
CookieCollection = _ts_decorate([
    ClientCollection.annotate({
        path: "/rcb-cookie",
        singlePath: "/rcb-cookie/:id",
        namespace: "wp/v2",
        methods: [
            RouteHttpVerb.GET
        ],
        request
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof CookieGroupModel === "undefined" ? Object : CookieGroupModel
    ])
], CookieCollection);
export { CookieCollection };
